import clsx from 'clsx';
import { RATINGS, Rating, formatInterval } from '../../scheduler/fsrs.js';
import styles from './Study.module.scss';

const TWO = [Rating.Again, Rating.Good];

export default function RatingBar({ intervals, onRate, suggested, showIntervals = true, buttons = 4, disabled }) {
  const list = buttons === 2 ? RATINGS.filter((r) => TWO.includes(r.value)) : RATINGS;
  return (
    <div
      className={clsx(styles.ratings, buttons === 2 && styles.ratingsTwo)}
      role="group"
      aria-label="How well did you remember?"
    >
      {list.map((r) => (
        <button
          key={r.value}
          type="button"
          className={clsx(styles.rate, styles[r.key], suggested === r.value && styles.suggested)}
          onClick={() => onRate(r.value)}
          disabled={disabled}
          aria-keyshortcuts={r.hotkey}
          aria-label={`${r.label}: ${r.hint}`}
        >
          <span className={styles.rateLabel}>{buttons === 2 && r.value === Rating.Good ? 'Got it' : r.label}</span>
          {showIntervals && intervals ? (
            <span className={styles.ivl}>{formatInterval(intervals[r.value])}</span>
          ) : null}
        </button>
      ))}
    </div>
  );
}
